import Vue from 'vue'
import Router from 'vue-router'
import WebForm from '@/components/WebForm/WebForm'
import WebDocument from '@/components/WebDocument/WebDocument'
import WebFormTaxPay from '@/components/WebFormTaxPay/WebFormTaxPay'
import FoomaWordDocument from '@/components/FoomaWordDocument/index'
import NoslusDotaznik from '@/components/NoslusSk/dotaznik'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/form/:formID/:expiration',
      name: 'WebForm',
      component: WebForm,
      meta: { title: 'Formulář', noCache: true }
    },
    {
      path: '/documents/:document_id/:expiration',
      name: 'WebDocument',
      component: WebDocument,
      meta: { title: 'Dokument k podepsání', noCache: true }
    },
    {
      path: '/fooma/:document_id/:expiration',
      name: 'FoomaWordDocument',
      component: FoomaWordDocument,
      meta: { title: 'Dokument k podpisaniu', noCache: true }
    },
    {
      path: '/noslus_sk/:id/:expiration',
      name: 'NoslusDotaznik',
      component: NoslusDotaznik,
      meta: { title: 'Dotaznik', noCache: true }
    },
    {
      path: '/form_taxpay/:formID/:expiration',
      name: 'WebFormTaxPay',
      component: WebFormTaxPay,
      meta: { title: 'Prohlášení poplatníka', noCache: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js